import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CorePersonSensitiveField } from "../../../models/CoreUser"
import { ClearSensitiveField, GetSensitiveField, UserState } from '../../../store/UserAction';
import { RequestState } from '../../../models/RequestState';
import StatusCode from '../../../util/StatusCode';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/store';

interface UserViewSensitiveFieldProps {
    userId: string
    field: CorePersonSensitiveField
    default?: string
    disabled?: boolean
}

interface UserViewSensitiveFieldState {
    users: UserState
}

const getSelector = (field: CorePersonSensitiveField): (state: UserViewSensitiveFieldState) => RequestState<string | undefined> => {
    switch (field) {
        case CorePersonSensitiveField.CivicNo:
            return state => state.users.sensitiveFields.civicNo;
        default:
            throw new Error("Invalid field");
    }
}

const UserViewSensitiveField: React.FC<UserViewSensitiveFieldProps> = (props) => {
    const { t } = useTranslation(['common']);
    const dispatch = useDispatch();
    const sensitiveField = useSelector<RootState, RequestState<string | undefined>>(getSelector(props.field))
    const defaultValue = props.default ?? '••••••••••';

    useEffect(() => {
        return () => ClearSensitiveField(props.field)(dispatch);
    }, [props.field, dispatch]);

    const show: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
        e.preventDefault();
        GetSensitiveField(props.userId, props.field)(dispatch);
    }

    const hide: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
        e.preventDefault();
        ClearSensitiveField(props.field)(dispatch);
    }

    switch (sensitiveField.code) {
        case StatusCode.NONE:
            return <span>{defaultValue}{!props.disabled && <> <a href="#" onClick={show}>{`[${t('action.show', {ns: 'common'})}]`}</a></>}</span>;
        case StatusCode.PENDING:
            return <span>{t('loading', { ns: 'common' })}</span>;
        case StatusCode.COMPLETE:
            return <span>{sensitiveField.data} <a href="#" onClick={hide}>{`[${t('action.hide', { ns: 'common' })}]`}</a></span>
        case StatusCode.ERROR:
            return <span>{t('error.somethingWentWrong', { ns: 'common' })} <a href="#" onClick={hide}>{`[${t('action.ok', { ns: 'common' })}]`}</a></span>
    }
}

export default UserViewSensitiveField;
